import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    jobRoleList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    jobRoleDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const jobRoleSlice = createSlice({
  name: 'jobRole',
  initialState,
  reducers: {
    getJobRoleList: (state, action) => {
        state.jobRoleList.requesting = true;
        state.jobRoleList.error = null;
        state.jobRoleList.items = [];
        state.jobRoleList.success = false;
        state.jobRoleList.filters = action.payload;
    },
    getJobRoleListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.jobRoleList.requesting = false;        
        state.jobRoleList.items = data;
        state.jobRoleList.success = true; 
        state.jobRoleList.pagination.current_page = current_page;
        state.jobRoleList.pagination.per_page = per_page;
        state.jobRoleList.pagination.total = total;
    },
    getJobRoletListFail: (state, action) => {        
        state.jobRoleList.requesting = false;
        state.jobRoleList.error = action.payload;
    },
    getJobRoleDetails: (state) => {
        state.jobRoleDetails.requesting = true;
        state.jobRoleDetails.error = null;
        state.jobRoleDetails.data = null;
        state.jobRoleDetails.success = false; 
    },
    getJobRoleDetailsSuccess: (state, action) => {
        state.jobRoleDetails.requesting = false;
        state.jobRoleDetails.data = action.payload;
        state.jobRoleDetails.success = true; 
    },
    getJobRoleDetailsFail: (state, action) => {        
        state.jobRoleDetails.requesting = false;
        state.jobRoleDetails.error = action.payload;
    },
    doJobRoleCreate: (state) => {
        state.jobRoleDetails.requesting = true;
        state.jobRoleDetails.error = null;
        state.jobRoleDetails.data = null;
        state.jobRoleDetails.success = false; 
    },
    doJobRoleUpdate: (state) => {
        state.jobRoleDetails.requesting = true;
        state.jobRoleDetails.error = null;
        state.jobRoleDetails.data = null;
        state.jobRoleDetails.success = false; 
    },
    doJobRoleDelete: (state) => {
        state.jobRoleDetails.requesting = true;
        state.jobRoleDetails.error = null;
        state.jobRoleDetails.data = null;
        state.jobRoleDetails.success = false; 
    },
  },
})

export const { 
    getJobRoleList, getJobRoleListSuccess, getJobRoleListFail,
    getJobRoleDetails, getJobRoleDetailsSuccess, getJobRoleDetailsFail,
    doJobRoleCreate, doJobRoleUpdate, doJobRoleDelete,
} = jobRoleSlice.actions

export default jobRoleSlice.reducer